import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';
import type { MotionProps } from '@/app/components/Motion';
import Motion from '@/app/components/Motion';

import type { ProfileData } from '../_data/profiles';
import ProfileModal from './ProfileModal';

export interface ProfileCardProps {
  readonly index: number;
  readonly profile: ProfileData;
}

export const getMotionProps = ({ index }: { index: number }): MotionProps => {
  return {
    initial: {
      opacity: 0,
      y: 100,
    },
    transition: {
      delay: 0.1 * index,
      duration: 0.5,
      type: 'tween',
    },
    viewport: {
      amount: 0.333,
      once: true,
    },
    whileInView: {
      opacity: 1,
      y: 0,
    },
  };
};

const ProfileCard = ({ index, profile }: ProfileCardProps) => {
  const t = useTranslations();
  const motionProps = getMotionProps({ index });

  return (
    <Motion className="flex flex-1 justify-center" {...motionProps}>
      <div
        className="max-w-[540px] md:w-full md:max-w-none"
        data-cy="leadership_profile_card"
      >
        <Image
          alt={profile.name}
          height={617}
          src={`${profile.imageUrl}.jpg?ar=540:617&crop=focalpoint&fit=crop`}
          width={540}
        />
        <div className="flex items-end justify-between md:block">
          <h2>
            <Typography
              className="mt-4 block text-xs tracking-widest uppercase"
              Element="span"
            >
              {t(profile.titleKey)}
            </Typography>
            <Typography className="block" Element="span" variant="h4">
              {profile.name}
            </Typography>
          </h2>
          <ProfileModal profile={profile} />
        </div>
      </div>
    </Motion>
  );
};

export default ProfileCard;
